import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=03322f08&"
import script from "./MessageCard.vue?vue&type=script&lang=js&"
export * from "./MessageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports